window.addEventListener('load', function (event) {
    let headerHeight = document.querySelector('#shopify-section-new-header').offsetHeight;
    let announcementHeight = document.querySelector('#shopify-section-announcement') ? document.querySelector('#shopify-section-announcement').offsetHeight : 0;
    let totalHeight = headerHeight + announcementHeight;
    const root = document.documentElement;
    root.style.setProperty('--header-height', totalHeight);
}, false);

window.addEventListener('load', function (event) {
    let quizStart = document.querySelector('.quiz-start') ? document.querySelector('.quiz-start') : false;

    document.querySelector('.js-quiz-start').addEventListener('click', function () {
        quizStart.classList.remove('quiz-step--active');
        document.querySelector('.quiz-step[data-step="1"]').classList.add('quiz-step--active');
    });

    let previousSteps = []; // Array to keep track of previous steps

    document.querySelectorAll('.quiz-step__controls .btn, .quiz-step__controls-submit').forEach(item => {
        item.addEventListener('click', function () {
            const currentStepElement = document.querySelector('.quiz-step--active');
            let currentStep = parseInt(currentStepElement.dataset.step);
            let selectedOption = null;

            if (this.classList.contains('quiz-steps__controls-next')) {
                currentStepElement.querySelectorAll('.quiz-step__option').forEach(option => {
                    if (option.classList.contains('quiz-step__option--active')) {
                        selectedOption = option.dataset.result;
                    }
                });

                if (selectedOption) {
                    const nextStepElement = document.querySelector(`.quiz-step[data-step="${currentStep + 1}"]`);
                    const finalStepElement = document.querySelector('.quiz-final');

                    if (nextStepElement) {
                        previousSteps.push(currentStep); // Track the current step before moving to the next
                        currentStepElement.classList.remove('quiz-step--active');
                        nextStepElement.classList.add('quiz-step--active');

                        // Show only the matching questions
                        const prevAnswer = currentStepElement.querySelector('.quiz-step__option--active .quiz-step__option-name')?.getAttribute('first-step-answer');
                        if (prevAnswer) {
                            let foundMatchingQuestion = false;
                            nextStepElement.querySelectorAll('.quiz-step__questions').forEach(questionSet => {
                                questionSet.classList.remove('show-question'); // Hide all questions initially
                                if (questionSet.getAttribute('prev-answer') === prevAnswer) {
                                    questionSet.classList.add('show-question');
                                    foundMatchingQuestion = true;
                                }
                            });

                            // If no matching question found, go to the final step
                            if (!foundMatchingQuestion) {
                                nextStepElement.classList.remove('quiz-step--active');
                                finalStepElement.classList.add('quiz-step--active');
                            }
                        }
                    } else {
                        previousSteps.push(currentStep); // Track the current step before moving to the final step
                        currentStepElement.classList.remove('quiz-step--active');
                        finalStepElement.classList.add('quiz-step--active');
                    }
                } else {
                    alert('Please select an option to proceed.');
                }
            } else if (this.classList.contains('quiz-steps__controls-prev')) {
                if (currentStepElement.classList.contains('quiz-final')) {
                    const lastStep = previousSteps.pop(); // Get the last visited step
                    const prevStepElement = document.querySelector(`.quiz-step[data-step="${lastStep}"]`);

                    if (prevStepElement) {
                        currentStepElement.classList.remove('quiz-step--active');
                        prevStepElement.classList.add('quiz-step--active');
                    }
                } else {
                    const prevStepElement = document.querySelector(`.quiz-step[data-step="${currentStep - 1}"]`);

                    if (prevStepElement) {
                        previousSteps.pop(); // Remove the current step from the history
                        currentStepElement.classList.remove('quiz-step--active');
                        prevStepElement.classList.add('quiz-step--active');
                    }
                }
            } else if (this.classList.contains('quiz-steps__controls-submit')) {
                let results = [];
                let resultsFullName = [];

                document.querySelectorAll('.quiz-step__option--active').forEach(option => {
                    let activeOption = option.dataset.result;
                    let activeOptionName = option.querySelector('.quiz-step__option-name').textContent;
                    results.push(activeOption);
                    resultsFullName.push(activeOptionName);
                });

                let quiz_result = results.join("");
                document.querySelector('#quiz-option-one').value = resultsFullName[0] || '';
                document.querySelector('#quiz-option-two').value = resultsFullName[1] || '';
                document.querySelector('#quiz-option-three').value = resultsFullName[2] || '';
                document.querySelector('#quiz-option-four').value = resultsFullName[3] || '';
                document.querySelector('.quiz-steps__controls-submit .btn__text').textContent = 'SUBMITTING...';

                // Generate URL based on quiz result
                const resultUrl = `/pages/quiz-results/qr${quiz_result}`;
                document.querySelector('.quiz-steps__controls-submit').setAttribute('href', resultUrl);
            }
        });
    });

    document.querySelectorAll('.quiz-step__option').forEach(option => {
        option.addEventListener('click', function () {
            const activeOption = this.parentNode.querySelector('.quiz-step__option--active');
            if (activeOption) {
                activeOption.classList.remove('quiz-step__option--active');
            }
            this.classList.add('quiz-step__option--active');

            // Clear subsequent steps when an answer is changed
            const currentStepElement = this.closest('.quiz-step');
            const currentStep = parseInt(currentStepElement.dataset.step);
            document.querySelectorAll(`.quiz-step[data-step="${currentStep + 1}"] .quiz-step__questions`).forEach(questionSet => {
                questionSet.classList.remove('show-question');
            });
        });
    });
}, false);










